import store from '@/store';
import { i18n } from '@/plugins/i18n';
import {
  HELP_LINKS_FF,
  BIZAI_CHAT_FF,
  AICHAT_ATTR,
  DEFAULT_QUESTION_KEY,
  HELP_WORKFLOW_NAME,
} from '../constants/helpConstants';

export function getAichatQuestion(el) {
  return (el && typeof el.getAttribute === 'function' && el.getAttribute(AICHAT_ATTR)) || null;
}

function isBizaiEligible() {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  const staffData = store.getters['StaffStore/staffData'];
  return !!hasFeature && !!hasFeature(BIZAI_CHAT_FF) && staffData?.role === 'admin';
}

export function helpDestination() {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  if (!hasFeature || !hasFeature(HELP_LINKS_FF)) return 'external';
  return isBizaiEligible() ? 'chat' : 'none';
}

export function openHelp({ message = null, source = 'help_article' } = {}) {
  store.dispatch('AiChatStore/launchWorkflow', {
    message: message || i18n.t(DEFAULT_QUESTION_KEY),
    context: { source },
    workflow: { name: HELP_WORKFLOW_NAME },
  });
}

export function installHelpGlobals(win = window) {
  /* eslint-disable no-param-reassign */
  win.helpDestination = () => helpDestination();
  win.openHelp = (opts) => openHelp(opts);
  /* eslint-enable no-param-reassign */
}

export function syncHelpLinkVisibility() {
  document.body.classList.toggle('bizai-help-hidden', helpDestination() === 'none');
}

export default {
  getAichatQuestion, helpDestination, openHelp, installHelpGlobals, syncHelpLinkVisibility,
};
